<app-ai-document-processing-disclaimer [matterDocumentType]="APSFileType" />

<app-container type="light" [id]="APS_SIDE_FORM_FRAGMENTS.AGREEMENT_DATE">
	<app-sale-agreement-date
		[skeletonLoading]="loading$ | async"
		(onFocus)="jumpToSection($event)"
	/>
</app-container>

<app-container type="light" [id]="APS_SIDE_FORM_FRAGMENTS.CLIENTS">
	<app-sale-clients-search-and-create
		label="Buyer(s)"
		[clientType]="buyerClientType"
		(onInputFocus)="jumpToSection($event)"
		[id]="APS_SIDE_FORM_FRAGMENTS.BUYER"
		data-intercom-target="aps-buyer"
		[hideIdv]="(matterFileType$ | async) === fileTypes.SALE"
		[skeletonLoading]="loading$ | async"
		[testHook]="testHooks.BuyerSaleClientsSearchAndCreate"
	/>

	<app-sale-clients-search-and-create
		label="Seller(s)"
		[clientType]="sellerClientType"
		(onInputFocus)="jumpToSection($event)"
		class="mt-2"
		[id]="APS_SIDE_FORM_FRAGMENTS.SELLER"
		[hideIdv]="(matterFileType$ | async) === fileTypes.PURCHASE"
		[skeletonLoading]="loading$ | async"
		[testHook]="testHooks.SellerSaleClientsSearchAndCreate"
	/>
</app-container>

<app-container type="light" [id]="APS_SIDE_FORM_FRAGMENTS.ADDRESS">
	<ng-container *ngIf="(loading$ | async) === false; else skeleton">
		<app-matter-address (onFocus)="jumpToSection($event)"></app-matter-address>
		<app-jurisdiction-field class="mt-2"></app-jurisdiction-field>
	</ng-container>
</app-container>

<app-container
	[title]="(loading$ | async) ? '' : 'Property Details'"
	type="light"
	[testHook]="testHooks.PropertyDetailsContainer"
	[id]="APS_SIDE_FORM_FRAGMENTS.PROPERTY_TYPE"
>
	<app-property-type *ngIf="(loading$ | async) === false; else skeleton" />
</app-container>

<app-container
	*ngIf="(propertyType$ | async)?.type === PropertyType.CONDO"
	[title]="(loading$ | async) ? '' : 'Condo Corporation & Management'"
	type="light"
	[id]="APS_SIDE_FORM_FRAGMENTS.CONDO"
>
	<app-sale-condo *ngIf="(loading$ | async) === false; else skeleton" />
</app-container>

<app-container type="light" [id]="APS_SIDE_FORM_FRAGMENTS.FINANCIALS">
	<app-sale-saleprice
		[id]="APS_SIDE_FORM_FRAGMENTS.PURCHASE_PRICE"
		label="Sale Price"
		(onFocus)="jumpToSection($event)"
	></app-sale-saleprice>
	<app-sale-deposit-side-form
		[id]="APS_SIDE_FORM_FRAGMENTS.DEPOSIT"
		label="Deposit Price"
		[skeletonLoading]="loading$ | async"
		[mode]="depositSideFormMode.SIDE_FORM"
		(onFocus)="jumpToSection($event)"
		class="mt-2"
	></app-sale-deposit-side-form>
	<app-deposit-holder-dropdown
		class="mt-2"
		[skeletonLoading]="loading$ | async"
		[mode]="depositHolderDropdownMode.SELF_UPDATING"
		[testHook]="testHooks.DepositHolderDropdown"
	></app-deposit-holder-dropdown>
</app-container>

<app-container type="light" [id]="APS_SIDE_FORM_FRAGMENTS.KEY_DATES">
	<app-occupancy-date
		*ngIf="(propertyType$ | async)?.status === propertyStatus.NEW"
		[skeletonLoading]="loading$ | async"
		(onFocus)="jumpToSection($event)"
		[id]="APS_SIDE_FORM_FRAGMENTS.OCCUPANCY_DATE"
		class="mb-2"
	/>
	<app-sale-closing-date
		[skeletonLoading]="loading$ | async"
		(onFocus)="jumpToSection($event)"
		[id]="APS_SIDE_FORM_FRAGMENTS.CLOSING_DATE"
	/>
	<app-sale-title-search-completion-date
		class="mt-2"
		[skeletonLoading]="loading$ | async"
		(onFocus)="jumpToSection($event)"
		[id]="APS_SIDE_FORM_FRAGMENTS.TITLE_SEARCH_COMPLETION_DATE"
	/>
</app-container>

<div
	class="flex gap-5"
	[ngClass]="
		(matterFileType$ | async) === fileTypes.PURCHASE
			? 'flex-col'
			: 'flex-col-reverse'
	"
	*ngIf="matterFileType$ | async"
>
	<app-container
		type="light"
		[id]="APS_SIDE_FORM_FRAGMENTS.BUYER_BROKERAGE"
		*ngIf="matterFileType$ | async"
	>
		<app-brokerage-side-form
			(onFocus)="jumpToSection($event)"
			[brokerageFieldType]="buyerBroker"
			[isClientBrokerage]="(matterFileType$ | async) === fileTypes.PURCHASE"
			[skeletonLoading]="loading$ | async"
			label="Buyer Agent or Brokerage"
			[testHook]="testHooks.BuyerAgentOrBrokerageSideForm"
		/>
	</app-container>
	<app-container
		type="light"
		[id]="APS_SIDE_FORM_FRAGMENTS.SELLER_AGENT_BROKERAGE"
	>
		<app-brokerage-side-form
			(onFocus)="jumpToSection($event)"
			[skeletonLoading]="loading$ | async"
			[brokerageFieldType]="sellerBroker"
			[isClientBrokerage]="(matterFileType$ | async) === fileTypes.SALE"
			label="Seller Agent or Brokerage"
			[testHook]="testHooks.SellerAgentOrBrokerageSideForm"
		/>
	</app-container>
</div>
<app-container type="light" [id]="APS_SIDE_FORM_FRAGMENTS.OTHER_LAWYER">
	<app-law-firms-side-form
		label="Other Party Lawyer or Law Firm"
		(onFocus)="jumpToSection($event)"
		[skeletonLoading]="loading$ | async"
		placeholder="Search Lawyer or Law Firm"
		[showClerk]="showClerk"
		[lawFirm]="lawFirm"
	/>
</app-container>
<app-container
	data-intercom-target="vtb-aps-side-form"
	type="light"
	*ngIf="
		(loading$ | async) === false &&
		((matterFileType$ | async) === fileTypes.SALE ||
			(matterFileType$ | async) === fileTypes.PURCHASE)
	"
>
	<div class="flex justify-between">
		<div class="flex-1">
			<h4>Vendor Take-Back</h4>
			<p>
				Enable the ability to create a vendor take-back mortgage for this file.
			</p>
		</div>
		<div class="ml-4">
			<atomic-switch
				[(ngModel)]="vtbMortgageExists"
				(ngModelChange)="toggleVTBMortgage($event)"
				[testHook]="testHooks.VtbMortgageExistsSwitch"
			></atomic-switch>
		</div>
	</div>

	<app-aps-vtb-form class="mt-4"></app-aps-vtb-form>
</app-container>

<ng-template #skeleton>
	<ui-skeleton-loader />
</ng-template>
